import { useEffect, useState } from "react";
import api from "./api";

// Nomor WhatsApp memakai sumber yang sama dengan footer website:
// Admin -> Konten Beranda -> "URL WhatsApp" (kontak_wa_url).
let cache = null;
let pending = null;

export function useWaUrl() {
  const [url, setUrl] = useState(cache);
  useEffect(() => {
    if (cache !== null) { setUrl(cache); return; }
    if (!pending) {
      pending = api.get("/api/konten-beranda")
        .then(({ data }) => { cache = (data?.kontak_wa_url || "").trim(); return cache; })
        .catch(() => { cache = ""; return cache; });
    }
    let hidup = true;
    pending.then((v) => { if (hidup) setUrl(v); });
    return () => { hidup = false; };
  }, []);
  return url || "";
}
